import Received from './component'

export default {
  path: 'received',
  element: <Received />,
}
